import React from 'react'
import PospForm from './PospForm'
import HowItWorks from './HowItWorks'
import WhoCanBeAPosp from './WhoCanBeAPosp'
import HowToBecomeAPosp from './HowToBecomeAPosp'
import WhyToPartnerWithUs from './WhyToPartnerWithUs'
import AdvantagesOfPosp from './AdvantagesOfPosp'

const PospComp = () => {
  return (
    <>
    <PospForm/>
    <HowItWorks/>
    <WhoCanBeAPosp/>
    <HowToBecomeAPosp/>
    <WhyToPartnerWithUs/>
    <AdvantagesOfPosp/>
    </>
  )
}

export default PospComp